import { RestSlice } from '../../../../redux/rest.slice';
import { IppIndustryAttachments } from '@rcp/types';
import { Resource, localizationService } from 'src/services';

export const ippAttachmentDetailSlice = new RestSlice<IppIndustryAttachments>(
	localizationService.getLocalizedString('ipp.attachments.detailsPageHeader'),
	Resource.IppIndustryAttachments
);
export default ippAttachmentDetailSlice.rests.reducer;
